export default "__VITE_ASSET__DJhzN9J$__"